(function () {

    /* globals angular, moment, $ */

    angular
        .module('ngmvac')
        .controller('DestinyController', DestinyController);

    DestinyController.$inject = ['$window', 'HotelFactory', 'DatosCotizador', 'DestinyFactory'];

    function DestinyController($window, HotelFactory, DatosCotizador, DestinyFactory) {
        var vm = this;
        vm.step = 1;
        vm.initialStay = {
            checkIn: moment().add(4, 'days').format('YYYY-MM-DD'),
            checkOut: moment().add(7, 'days').format('YYYY-MM-DD')
        };
        var code = $('#code').val();
        var name = $('#name').val();
        var token = $('#token').val();
        setTimeout(function () {
            vm.initializationData = {destination: {code: code, name : name}, stay: vm.initialStay, token : token};
        }, 1000);

        vm.hotels = [];
        var path = $window.location.pathname;
        var fields = path.split('/');
        vm.press = fnPress;

        function fnPress($event) {
            console.log($event, "EVENT");
            vm.loaderStyle = {
                display: 'block'
            };
            if ($event.isValid) {
                HotelFactory
                    .obtenerHoteles()
                    .then(function (response) {
                        switch (response.status) {
                            case 204:

                                break;
                            case 200:
                                if (DatosCotizador.type === 'Hotel') {
                                    $window.location.href = '/hotel/details/' + DatosCotizador.destination.token;
                                } else {
                                    $window.location.href = '/hotelv2';
                                }
                                break;
                        }
                    })
                    .catch(function (err) {
                        vm.loaderStyle = {
                            display: 'none'
                        };
                        switch (err.status) {
                            case 422:
                                var message = '';
                                for (var field in err.data) {
                                    angular.forEach(err.data[field], function (error) {
                                        message += '<div>' + error + '</div>';
                                    });
                                }
                                alertMsg(message);
                                break;
                            default:
                                alertMsg('No hemos podido procesar su petición. Intente de nuevo.');
                                break;
                        }
                    });
            }
        }
    }

})();